// Typelizer digest 250d182aebd3f48c0ab8fdbf9dd88579
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from './runtime'
import { buildUrl } from './runtime'

export default {
  /** GET /setup */
  show: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/setup', {}, options),
    method: 'get',
  }),
}
